"use strict";

var _ = require("./utils/mindash");
var uuid = require("./utils/uuid");

function ActionPayload(options) {
  options || (options = {});

  var stores = [];
  var components = [];
  var rollbackHandlers = [];
  var actionHandledCallbacks = {};

  _.extend(this, options);

  this.id = options.id || uuid.small();
  this.type = actionType(options.type);
  this.arguments = _.toArray(options.arguments);

  this.toJSON = toJSON;
  this.handled = handled;
  this.toString = toString;
  this.rollback = rollback;
  this.addStoreHandler = addStoreHandler;
  this.onActionHandled = onActionHandled;
  this.addRollbackHandler = addRollbackHandler;
  this.addComponentHandler = addComponentHandler;
  this.timestamp = options.timestamp || new Date();

  Object.defineProperty(this, "stores", {
    get: function get() {
      return stores;
    }
  });

  Object.defineProperty(this, "components", {
    get: function get() {
      return components;
    }
  });

  function actionType(type) {
    if (_.isFunction(type)) {
      return type.toString();
    }

    return type;
  }

  function toString() {
    return JSON.stringify(this.toJSON(), null, 2);
  }

  function toJSON() {
    var json = _.pick(this, "id", "type", "stores", "arguments", "timestamp", "components");

    return json;
  }

  function rollback() {
    var _this = this;

    _.each(rollbackHandlers, function (rollback) {
      return rollback(_this.error);
    });
  }

  function handled() {
    _.each(actionHandledCallbacks, function (callback) {
      return callback();
    });
  }

  function onActionHandled(id, cb) {
    actionHandledCallbacks[id] = cb;
  }

  function addComponentHandler(component, store) {
    components.push(_.extend({
      id: uuid.small(),
      store: store.id || store.displayName
    }, component));
  }

  function addStoreHandler(store, handlerName) {
    stores.push({
      id: uuid.small(),
      handler: handlerName,
      store: store.id || store.displayName
    });
  }

  function addRollbackHandler(rollbackHandler, context) {
    if (_.isFunction(rollbackHandler)) {
      if (context) {
        rollbackHandler = _.bind(rollbackHandler, context);
      }

      rollbackHandlers.push(rollbackHandler);
    }
  }
}

module.exports = ActionPayload;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/actionPayload.js
 ** module id = 447
 ** module chunks = 0
 **/